import { createFileRoute } from '@tanstack/react-router'
import FinancialDashboard from '../../../app/financial/financial-dashboard'

export const Route = createFileRoute('/_auth/financial/dashboard')({
  component: FinancialDashboard
})
